// The app's instance of page-upload (see page-upload.js): uploads through the Firebase Storage SDK.
import firebase from 'firebase/app';
import 'firebase/storage';
import { makeUploadPageFile } from './page-upload';

export default makeUploadPageFile(path => firebase.storage().ref(path));


// WEBPACK FOOTER //
// ./src/lib/page-upload-client.js